const enviroment = {
    sysApiUrl: process.env.REACT_APP_SYS_API_URL,
    fpalphaApiUrl: process.env.REACT_APP_FPALPHA_API_URL,
    paymentApiUrl: process.env.REACT_APP_PAYMENT_API_URL,
    resourcesApiUrl: process.env.REACT_APP_RESOURCES_API_URL,
    authApiUrl: process.env.REACT_APP_AUTH_API_URL,
    fpalphaUrl: process.env.REACT_APP_FPALPHA_URL,
    advisorApiUrl: process.env.REACT_APP_ADVISOR_API_URL,
    documentApiUrl: process.env.REACT_APP_DOCUMENT_API_URL,
    timeZone: process.env.REACT_APP_TIME_ZONE,
    socketUrl: process.env.REACT_APP_SOCKET_URL,
}

export default enviroment